<template>
  <div>
    <v-card
      ><v-tabs v-model="tab" background-color="primary" dark>
        <v-tab>Ajustes de Sucursal</v-tab>
        <v-tab>Mi usuario</v-tab>
        <v-tab @click="obtenerSucursales">Sucursales</v-tab>
      </v-tabs>

      <v-card-text>
        <!-- Esto era el controlador fiscal
            <v-text-field
              v-model="sucursal.controladorFiscal.ip"
              type="text"
              append-icon="mdi-open-in-new"
              label="Direccion del Controlador Fiscal"
              @click:append="irWebCF()"
              readonly
            ></v-text-field>
            <v-treeview
              open-all
              :items="sucursal.controladorFiscal.estado"
            ></v-treeview>
            <v-btn
              block
              color="red"
              dark
              @click="cancelarComprobanteCF"
              :loading="loadingcCCF"
              >Cancelar comprobante actual</v-btn
            > -->
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-row>
              <v-col cols="12" md="6">
                <v-skeleton-loader
                  type="table-tbody"
                  v-if="loadingCategorias"
                ></v-skeleton-loader>
                <v-simple-table v-else>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Categorias
                        </th>
                        <th class="text-left">¿Ocultar en la Tienda?</th>
                        <th class="text-left"></th>
                        <th class="text-left"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in categorias" :key="index">
                        <td>{{ item.nombre }}</td>
                        <td><v-checkbox disabled v-model="item.ocultarTienda"></v-checkbox></td>
                        <td>
                          <v-img
                            :src="item.foto"
                            v-if="item.foto"
                            width="64"
                            height="64"
                          ></v-img>
                        </td>
                        
                        <td>
                          <v-btn icon @click="editarCategoria(index)"
                            ><v-icon>mdi-pencil</v-icon></v-btn
                          ><v-btn icon @click="borrarCategoria(item._id)"><v-icon>mdi-delete</v-icon></v-btn>
                        </td>
                      </tr>
                      <tr>
                        
                        <td>
                          <v-text-field
                            v-model="categoria.nombre"
                          ></v-text-field>
                        </td>

                        <td><v-checkbox v-model="categoria.ocultarTienda"></v-checkbox></td>

                        <td>
                          <v-img
                            :src="categoria.foto"
                            v-if="categoria.foto"
                            width="64"
                            height="64"
                          ></v-img>
                          <v-file-input
                            accept="image/png, image/jpeg, image/bmp"
                            prepend-icon="mdi-camera"
                            label="Foto"
                            @change="cambiarFoto"
                            show-size
                          ></v-file-input>
                          <span class="red--text">{{ fotoError }}</span>
                        </td>
                        <td>
                          <v-btn icon @click="guardarCategoria()"><v-icon>mdi-check</v-icon></v-btn
                          ><v-btn icon v-if="categoria._id" @click="borrarCategoria(categoria._id)"><v-icon>mdi-delete</v-icon></v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-text-field
              v-model="password_actual"
              :append-icon="pwd1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="pwd1 ? 'text' : 'password'"
              label="Contraseña actual"
              counter
              @click:append="pwd1 = !pwd1"
            ></v-text-field>
            <v-text-field
              v-model="password"
              :append-icon="pwd ? 'mdi-eye' : 'mdi-eye-off'"
              :type="pwd ? 'text' : 'password'"
              label="Nueva contraseña"
              hint="Minimo 8 caracteres"
              counter
              @click:append="pwd = !pwd"
            ></v-text-field>
            <v-text-field
              v-model="re_password"
              :append-icon="pwd2 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="pwd2 ? 'text' : 'password'"
              label="Repetir contraseña"
              hint="Las contraseñas deben coincidir"
              counter
              @click:append="pwd2 = !pwd2"
            ></v-text-field>
            <v-btn
              block
              :color="comprobarPass ? 'green' : 'red'"
              dark
              @click="guardarPass"
              :loading="loadingPwd"
              >Guardar nueva contraseña</v-btn
            >
          </v-tab-item>
          <v-tab-item>
            <v-select
              :loading="loadingSucursales"
              :items="sucursales"
              label="Sucursal seleccionada"
              v-model="sucursal.nuevo"
            ></v-select>
            <v-btn
              block
              dark
              color="primary"
              @click="guardarSucursal"
              :loading="loadingSucursales"
              >Cambiar sucursal</v-btn
            >
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Ajustes",
  data() {
    return {
      tab: 0,
      tabAjustes: 0,
      password: "",
      password_actual: "",
      re_password: "",
      pwd: 0,
      pwd1: 0,
      pwd2: 0,
      sucursal: {
        controladorFiscal: {
          ip: "",
          estado: [],
        },
        actual: "",
        nuevo: "",
        roles: "",
      },
      categoria: {
        foto: "",
        nombre: "",
        ocultarTienda: false
      },
      fotoError: null,
      sucursales: [],
      categorias: [],
      loadingCategorias: true,
      loadingPwd: false,
      loadingcCCF: true,
      loadingSucursales: true,
    };
  },
  async created() {
    try {
      const sucursal = await axios.get("/sucursal");
      this.sucursal = sucursal.data;
      this.obtenerCategorias();
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    async guardarPass() {
      if (this.comprobarPass) {
        try {
          const pwd = await axios.put("/usuario/editar/pwd", {
            actual: this.password_actual,
            password: this.password,
          });
          if (pwd)
            alert(
              "Contraseña actualizada con exito. Por favor, vuelva a iniciar sesion."
            );
          if ($cookies.isKey("token")) $cookies.remove("token");
          this.$router.push("/login");
        } catch (e) {
          alert(
            "No se pudo actualizar la contraseña. Verifique los datos e intente nuevamente."
          );
        }
      }
    },
    irWebCF() {
      window.open(this.sucursal.controladorFiscal.ip);
    },
    async cancelarComprobanteCF() {
      if (
        confirm(
          "¿Cancelar comprobante en curso? Esta operacion no se puede deshacer."
        )
      ) {
        this.loadingcCCF = true;
        try {
          const cancelar = await axios.post(
            `${this.sucursal.controladorFiscal.ip}/fiscal.json`,
            JSON.stringify({
              Cancelar: {},
            }),
            {
              headers: {
                "Content-Type": "application/json",
              },
              fiscal: true,
            }
          );
          alert(
            cancelar
              ? "Operacion realizada."
              : "No se pudo realizar la operacion. Intente nuevamente."
          );
        } catch (error) {
          alert("No hay conexion con el Controlador Fiscal.");
        }
        this.loadingcCCF = false;
      }
    },
    async obtenerSucursales() {
      this.loadingSucursales = true;
      try {
        const sucursales = (await this.axios.get("/usuario")).data.sucursales;
        this.sucursal.actual = sucursales.actual;
        sucursales.roles.forEach((element) => {
          this.sucursales.push({
            text: element.sucursal.descripcion,
            value: element.sucursal._id,
          });
        });
        this.sucursal.nuevo = sucursales.actual;
      } catch (error) {}
      this.loadingSucursales = false;
    },
    async obtenerCategorias() {
      this.loadingCategorias = true;
      try {
        const categorias = await this.axios.get("/categoriasF");
        this.categorias = categorias.data;
      } catch (error) {
        console.log(error);
      }
      this.loadingCategorias = false;
    },
    editarCategoria(i) {
      let c = this.categorias[i]
      this.categoria = 
      {
        nombre : c.nombre,
        foto: c.foto,
        ocultarTienda: c.ocultarTienda,
        _id: c._id
      }
    },
    async guardarCategoria() {
      try {
        await this.axios.post('/categoria', this.categoria)
        this.categoria = {
          nombre : "",
          foto: "",
          ocultarTienda: false
        }
        this.obtenerCategorias()
      } catch (error) {
        console.log(error)
      }
    },
    async borrarCategoria(_id) {
      if(confirm("Si existe algun producto en esta categoría, se desvinculará y quedará sin categoría. ¿Confirma eliminar la categoría?"))
      {
        try {
          await this.axios.delete('/categoria/' + _id)
        this.obtenerCategorias()
        } catch (error) {
          console.log(error)
        }
      }
    },
    cambiarFoto(event) {
      this.categoria.foto = "";
      const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
      if (event) {
        if (!allowedTypes.includes(event.type)) {
          this.fotoError = "El archivo no es una imagen.";
        } else if (event.size > 2000000) {
          this.fotoError =
            "El archivo es muy grande. Seleccione una imagen menor a 2Mb.";
        } else {
          this.fotoError = null;
          const reader = new FileReader();
          reader.readAsDataURL(event);
          reader.onload = (e) => {
            this.categoria.foto = e.target.result;
          };
        }
      }
    },
    async guardarSucursal() {
      this.loadingSucursales = true;
      try {
        if (this.sucursal.actual != this.sucursal.nuevo) {
          const cambiar = await this.axios.put("/usuario/editar/sucursal", {
            sucursal: this.sucursal.nuevo,
          });
          if (cambiar)
            alert(
              "Se realizo el cambio de Sucursal. Por favor, vuelva a iniciar sesion."
            );
          if ($cookies.isKey("token")) $cookies.remove("token");
          this.$router.push("/login");
        }
      } catch (error) {
        alert("No se pudo cambiar la Sucursal. Por favor, intente nuevamente.");
      }
      this.loadingSucursales = false;
    },
  },
  computed: {
    comprobarPass() {
      return this.password === this.re_password &&
        this.password.length > 7 &&
        this.password_actual.length > 7 &&
        this.password != this.password_actual
        ? true
        : false;
    },
  },
};
</script>
